import ActionBar, { Left, Right, Heading } from './ActionBar'

export default Object.assign(ActionBar, {
  Left,
  Right,
  Heading
})
